import React, {FunctionComponent, useContext} from "react";
import {PageContext, PageContextProps} from "/src/contexts/Page";
import styledTheme from "/src/ui/shared/styledTheme";
import { theme as themeColor } from '/src/assets/theme';
import {Header} from "/src/ui/shared/header";
import {Link, StyledEngineProvider, ThemeProvider, GlobalStyles} from "@mui/material";
import {Footer} from "/src/ui/shared/footer";
import {ChallengeTeamProvider} from "/src/contexts/ChallengeTeamContext";
import {makeStyles, ThemeProvider as ThemeProviderForStyles} from '@mui/styles';
import {ChallengeUserRatingData} from "/src/domain/challenges/ChallengeUserRatingData";
import {RatingHeader} from "/src/ui/challengeUserRating/RatingHeader";
import {PersonalBestCarousel} from "/src/ui/challengeUserRating/PersonalBestCarousel";
import {SeasonRatingView} from "/src/ui/challengeUserRating/SeasonRatingView";
import {useTranslation} from "react-i18next";
import {links} from "/src/domain/shared/links";


export const ChallengeUserRatingApp = (): JSX.Element | null => {
    const {pageData} = useContext(PageContext) as PageContextProps;
    if (pageData === null) return null;

    return (
        <StyledEngineProvider injectFirst>
            <GlobalStyles
                styles={{
                    'body': {
                        backgroundColor: themeColor.WHITE_COLOR,
                    },
                }}
            />
            <ThemeProvider theme={styledTheme}>
                <ThemeProviderForStyles theme={styledTheme}>
                    <App/>
                </ThemeProviderForStyles>
            </ThemeProvider>
        </StyledEngineProvider>

    );
}

const App: FunctionComponent<any> = () => {
    const classes = useStyles();
    const {t} = useTranslation();

    const {pageData, currentUser, pageConfig, setPageData} = useContext(PageContext) as PageContextProps;

    const userRating = pageData as ChallengeUserRatingData;

    return (
        <>
            {pageConfig?.header && <Header currentUser={currentUser}/>}
            <ChallengeTeamProvider updateData={setPageData}>
                <div className={classes.contentContainer}>
                    <RatingHeader user={userRating.user}/>
                    <PersonalBestCarousel pbs={userRating.pb}/>
                    <Link
                        className={classes.showPredictionsLink}
                        href={`${links.challengesOrigin}/rating-more?user=${userRating.user.id}&showpredictions=1`}>
                        {t('showPredictions')}
                    </Link>
                    <div className={classes.seasonsContainer}>
                        {userRating.ratings.map(s => (<SeasonRatingView rating={s} key={s.season.name}/>))}
                    </div>
                </div>
            </ChallengeTeamProvider>
            {pageConfig?.footer && <Footer/>}
        </>
    )
}

const useStyles = makeStyles((muiTheme) => {
    return ({
        contentContainer: {
            [muiTheme.breakpoints.up("sm")]: {
                maxWidth: "1100px",
                minHeight: "calc(100vh - 20rem)",
                margin: "0 auto",
                padding: "1.5rem"
            },
            minHeight: "calc(100vh - 23rem)",
        },
        seasonsContainer: {
            margin: "1rem 0"
        },
        showPredictionsLink: {
            display: "block",
            margin: '1rem 0',
            textAlign: "center"
        }
    })
});